<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { transforms } from '@/parcours/flows/shared/transforms';
import RowItem from '@/molecules/RowItem.vue';

const route = useRoute();

type ConfigItem = {
  key: string;
  label: string;
  type?: string;
  showIf?: (data: any) => boolean;
};

type ConfigCategory = {
  title: string;
  description?: string;
  items: ConfigItem[];
};

const props = defineProps<{
  data: Record<string, any>;
  config: Record<string, ConfigCategory>;
}>();

// 🔥 catégorie depuis URL
const symptom = computed(() => route.query.symptom as string);

// 🔥 catégorie active
const category = computed(() => props.config?.[symptom.value]);

// 🔥 items filtrés
const filteredItems = computed(() => {
  const items = category.value?.items || [];

  return items.filter((item) => {
    if (!item.showIf) return true;

    try {
      return item.showIf(props.data?.request);
    } catch {
      return true;
    }
  });
});

// 🔥 affichage valeur avec transform
const getDisplayValue = (item: ConfigItem) => {
  const rawValue = props.data?.request?.[item.key];

  if (item.type && transforms[item.type]) {
    try {
      return transforms[item.type](rawValue, props.data?.request);
    } catch (e) {
      console.error('Transform error:', e);
      return '—';
    }
  }

  return rawValue ?? '—';
};
</script>
<template>
  <div class="mt-4">
    <RowItem
      v-for="item in filteredItems"
      :id="item.key"
      :key="item.key"
      :bordered="false"
      :description="getDisplayValue(item)"
      :title="item.label"
      title-wrap
    />
  </div>
</template>
